import { render, staticRenderFns } from "./EditPrinterLoader.vue?vue&type=template&id=8f005e14"
import script from "./EditPrinterLoader.vue?vue&type=script&lang=ts"
export * from "./EditPrinterLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports